__turbopack_context__.v({
  "body": "modal-module__09A2QG__body",
  "close": "modal-module__09A2QG__close",
  "footer": "modal-module__09A2QG__footer",
  "header": "modal-module__09A2QG__header",
  "isOpen": "modal-module__09A2QG__isOpen",
  "modal": "modal-module__09A2QG__modal",
  "modal-full": "modal-module__09A2QG__modal-full",
  "modal-lg": "modal-module__09A2QG__modal-lg",
  "modal-md": "modal-module__09A2QG__modal-md",
  "modal-sm": "modal-module__09A2QG__modal-sm",
  "root": "modal-module__09A2QG__root",
  "rootInline": "modal-module__09A2QG__rootInline",
  "scrim": "modal-module__09A2QG__scrim",
  "title": "modal-module__09A2QG__title",
});
